// Mock data for Splitwise clone

export const mockUser = {
  id: '1',
  name: 'Alex Johnson',
  email: 'alex.johnson@example.com',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
  totalBalance: 42.50,
  paymentMethods: [
    {
      id: 'pm_1',
      type: 'card',
      last4: '4242',
      brand: 'visa',
      isDefault: true
    },
    {
      id: 'pm_2',
      type: 'venmo',
      username: '@alex-johnson',
      isDefault: false
    }
  ]
};

export const mockGroups = [
  {
    id: '1',
    name: 'Weekend Trip',
    description: 'Cabin rental and expenses',
    avatar: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=150&h=150&fit=crop',
    members: [
      { id: '1', name: 'Alex Johnson', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face' },
      { id: '2', name: 'Sarah Chen', avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face' },
      { id: '3', name: 'Mike Torres', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face' },
      { id: '4', name: 'Lisa Park', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50&h=50&fit=crop&crop=face' }
    ],
    balance: 23.50,
    totalSpent: 485.90,
    lastActivity: '2024-07-20T10:30:00Z'
  },
  {
    id: '2',
    name: 'Roommates',
    description: 'Apartment expenses',
    avatar: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=150&h=150&fit=crop',
    members: [
      { id: '1', name: 'Alex Johnson', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face' },
      { id: '5', name: 'David Kim', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&h=50&fit=crop&crop=face' },
      { id: '6', name: 'Emma Wilson', avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=50&h=50&fit=crop&crop=face' }
    ],
    balance: -18.20,
    totalSpent: 1240.80,
    lastActivity: '2024-07-22T14:15:00Z'
  },
  {
    id: '3',
    name: 'Office Lunch',
    description: 'Team lunch expenses',
    avatar: 'https://images.unsplash.com/photo-1567521464027-f127ff144326?w=150&h=150&fit=crop',
    members: [
      { id: '1', name: 'Alex Johnson', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face' },
      { id: '7', name: 'Rachel Green', avatar: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=50&h=50&fit=crop&crop=face' },
      { id: '8', name: 'Tom Anderson', avatar: 'https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=50&h=50&fit=crop&crop=face' }
    ],
    balance: 15.75,
    totalSpent: 156.90,
    lastActivity: '2024-07-23T12:45:00Z'
  }
];

export const mockExpenses = [
  {
    id: '1',
    groupId: '1',
    description: 'Cabin Rental',
    amount: 320.00,
    paidBy: { id: '2', name: 'Sarah Chen' },
    splitBetween: ['1', '2', '3', '4'],
    category: 'accommodation',
    date: '2024-07-20T10:00:00Z',
    receipt: null
  },
  {
    id: '2',
    groupId: '1',
    description: 'Groceries for weekend',
    amount: 89.45,
    paidBy: { id: '1', name: 'Alex Johnson' },
    splitBetween: ['1', '2', '3', '4'],
    category: 'food',
    date: '2024-07-20T15:30:00Z',
    receipt: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=200&h=150&fit=crop'
  },
  {
    id: '3',
    groupId: '2',
    description: 'Internet Bill',
    amount: 65.00,
    paidBy: { id: '5', name: 'David Kim' },
    splitBetween: ['1', '5', '6'],
    category: 'utilities',
    date: '2024-07-22T09:00:00Z',
    receipt: null
  },
  {
    id: '4',
    groupId: '3',
    description: 'Pizza lunch',
    amount: 42.50,
    paidBy: { id: '1', name: 'Alex Johnson' },
    splitBetween: ['1', '7', '8'],
    category: 'food',
    date: '2024-07-23T12:30:00Z',
    receipt: null
  }
];

export const mockCategories = [
  { id: 'food', name: 'Food & Drinks', icon: 'UtensilsCrossed', color: '#FF6B6B' },
  { id: 'accommodation', name: 'Accommodation', icon: 'Home', color: '#4ECDC4' },
  { id: 'transport', name: 'Transportation', icon: 'Car', color: '#45B7D1' },
  { id: 'entertainment', name: 'Entertainment', icon: 'Music', color: '#96CEB4' },
  { id: 'utilities', name: 'Utilities', icon: 'Zap', color: '#FFEAA7' },
  { id: 'shopping', name: 'Shopping', icon: 'ShoppingBag', color: '#DDA0DD' },
  { id: 'other', name: 'Other', icon: 'MoreHorizontal', color: '#B0B0B0' }
];

export const mockNotifications = [
  {
    id: '1',
    type: 'expense_added',
    message: 'Sarah Chen added "Cabin Rental" in Weekend Trip',
    timestamp: '2024-07-20T10:30:00Z',
    read: false
  },
  {
    id: '2',
    type: 'payment_reminder',
    message: 'You owe David Kim $21.67 for Roommates expenses',
    timestamp: '2024-07-22T14:15:00Z',
    read: false
  },
  {
    id: '3',
    type: 'settle_up',
    message: 'Mike Torres settled up $80.00 in Weekend Trip',
    timestamp: '2024-07-19T16:45:00Z',
    read: true
  }
];

export const mockPaymentHistory = [
  {
    id: 'p1',
    fromUserId: '1',
    toUserId: '5',
    amount: 25.50,
    groupId: '2',
    groupName: 'Roommates',
    paymentMethod: 'card',
    status: 'completed',
    note: 'Internet bill payment',
    createdAt: '2024-07-22T10:00:00Z',
    completedAt: '2024-07-22T10:02:00Z'
  },
  {
    id: 'p2',
    fromUserId: '2',
    toUserId: '1',
    amount: 80.00,
    groupId: '1',
    groupName: 'Weekend Trip',
    paymentMethod: 'venmo',
    status: 'completed',
    note: 'Cabin rental split',
    createdAt: '2024-07-21T16:30:00Z',
    completedAt: '2024-07-21T16:35:00Z'
  }
];

// Helper functions
export const getGroupBalance = (groupId, userId) => {
  const group = mockGroups.find(g => g.id === groupId);
  return group ? group.balance : 0;
};

export const getUserExpenses = (userId) => {
  return mockExpenses.filter(expense => 
    expense.paidBy.id === userId || expense.splitBetween.includes(userId)
  );
};

export const getGroupExpenses = (groupId) => {
  return mockExpenses.filter(expense => expense.groupId === groupId);
};